import { Checkbox, Combobox, Flex, Text } from "@mantine/core";
import { type ClassNameValue, twMerge } from "tailwind-merge";

import type { SingleOrArray } from "@/types/utils";
import { stopPropagationWrapper } from "@/utils/ui";

interface AssignUserOptionProps {
  className?: SingleOrArray<ClassNameValue>;
  testId?: string;
  multi: boolean;
  primaryText: string;
  secondaryText?: string;
  selected: boolean;
  value: string;
}

export const OPTION_WIDTH = 300;

export const AssignUserOption = ({
  className = [],
  testId,
  multi,
  primaryText,
  secondaryText,
  selected,
  value,
}: AssignUserOptionProps) => {
  return (
    <Combobox.Option
      className={twMerge(["border-b", "border-uw-gray-0", "p-3"], className)}
      // When used in the assign user cell, click events propagate up to the row
      // and trigger navigation
      onClick={stopPropagationWrapper()}
      data-testid={testId}
      value={value}
      w={OPTION_WIDTH}
    >
      <Flex>
        {multi && <Checkbox className="mr-2" checked={selected} readOnly />}
        <Flex className="overflow-hidden" direction="column">
          <Text
            className={twMerge([
              "overflow-hidden",
              "text-ellipsis",
              "text-nowrap",
            ])}
            size="sm"
          >
            {primaryText}
          </Text>
          <Text c="gray.5" size="xs">
            {secondaryText}
          </Text>
        </Flex>
      </Flex>
    </Combobox.Option>
  );
};
